/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetWidgetActionToFormAction } from '../widget-to-form/send-dark-tweet'

const SPEED_THREAD_RESET_WIDGET_TYPE = 'SPEED_THREAD_RESET'
const SPEED_THREAD_RESET_FORM_TYPE = 'Reset Speed Thread'

const isSpeedThreadResetWidgetType = R.propEq(
  'type',
  SPEED_THREAD_RESET_WIDGET_TYPE
)

const convertSpeedThreadResetToForm = action => {
  const formAction = {
    ...R.pipe(
      R.prop('success'),
      R.head,
      convertSendDarkTweetWidgetActionToFormAction
    )(action),
    type: SPEED_THREAD_RESET_FORM_TYPE
  }
  return formAction
}

export {
  isSpeedThreadResetWidgetType,
  convertSpeedThreadResetToForm,
  SPEED_THREAD_RESET_FORM_TYPE
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/reset-speed-thread.js